import { DesignData, MediaText } from 'editor/src/store/design/types';

/** uuid → column of every text printing a code-set column, across all spreads. */
function collectBoundTextColumns(designData: DesignData | undefined): Map<number, string> {
  const columns = new Map<number, string>();
  designData?.spreads.forEach((spread) =>
    spread.pages.forEach((page) =>
      page.groups.media?.forEach((element) => {
        const column = element.type === 'text' ? (element as MediaText).extra.variableColumn : undefined;
        if (column) {
          columns.set(element.uuid, column);
        }
      }),
    ),
  );
  return columns;
}

export default collectBoundTextColumns;
